var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm._.steps},_vm._l((_vm.list),function(item,index){return _c('div',{key:item,class:[
      _vm._.item,
      _vm.currentIndex === index
        ? _vm._.current
        : index < _vm.currentIndex
        ? _vm._.finished
        : _vm._.pending ]},[_c('div',{class:_vm._.icon}),_c('div',{class:_vm._.label},[_vm._v(" "+_vm._s(item)+" ")])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }